import { atom } from "recoil";

export const patientListTableDataState = atom({
  key: "patientListTableDataState",
  default: [],
});

export const hasMorePatientDataState = atom({
  key: "hasMorePatientDataState",
  default: true,
});

export const patientListPageState = atom({
  key: "patientListPageState",
  default: 2,
});

export const patientListSearchQuery = atom({
  key: "patientListSearchQuery",
  default: "",
});

export const patientListTotalCount = atom({
  key: "patientListTotalCount",
  default: 0,
});

export const patientName = atom({
  key: "patientName",
  default: "",
});

export const currentPatientData = atom({
  key: "currentPatientData",
  default: {},
});
